import React from 'react';
import PropTypes from 'prop-types';
import Button from '@deliveroo/consumer-component-library/components/Button';

import i18n from '../../utils/i18n';
import styles from './styles.scss';

const ErrorPageContent = ({ children, isError, title }) => {
  const onBack = () => window.history.back();
  return (
    <div>
      <div className={styles.errorPage}>
        <div>
          <h1>{title}</h1>
          {children || (
            <>
              {isError ? (
                <p>Something didn&#39;t go as planned. Sorry about that!</p>
              ) : (
                <p>
                  Sorry, but the page you are looking for doesn&#39;t exist.
                  <br />
                  But there&#39;s loads more to see!
                </p>
              )}

              <div>
                {isError ? (
                  <Button type="primary" onClick={onBack}>
                    {i18n.gettext('Try again')}
                  </Button>
                ) : (
                  <Button type="primary" href="/">
                    {i18n.gettext('Go Home')}
                  </Button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

ErrorPageContent.propTypes = {
  isError: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

ErrorPageContent.defaultProps = {
  children: undefined,
};

export default ErrorPageContent;
